export function handleAnchor() {
  // Handle initial page load with hash
  if (window.location.hash) {
    setTimeout(() => {
      const target = document.querySelector(window.location.hash);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100); // Wait for GSAP animations to initialize
  }

  // Handle anchor links clicks
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href*="#"]');
    if (!link) return;

    const href = link.getAttribute('href');
    const hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;

    const hash = href.substring(hashIndex);
    const url = href.substring(0, hashIndex);

    // If it's the same page or no URL specified, handle smooth scroll
    if (!url || url === window.location.pathname || url === window.location.href.split('#')[0]) {
      const target = document.querySelector(hash);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        // Update URL without triggering page reload
        history.pushState(null, null, hash);
      }
    }
  });
}